<template>
  <div>
    <CRow class="main-content">

      <CCol col="12 col-md-9">
        <CCard>
          <CCardHeader>
  <strong>ثبت نوشته</strong>

          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="4">
                <CInput
                    v-model="title"
class="required"
                    label="عنوان نوشته"
                    placeholder="عنوان"
                    vertical
                />
              </CCol>
              <CCol col="4">
                <CInput
                    v-model="seo_title"
                    class="required"

                    label="سئو عنوان"
                />
                <SeoProgress :min_perfect="50" :max_perfect="60" :string="seo_title"/>

              </CCol>
              <CCol col="4">
                <CInput
                    v-model="keyword"
                    label="کلید واژه"
                />
              </CCol>
              <CCol col="4">
                <CInput
                    v-model="favorite_url"
                    label="لینک نوشته"
                    placeholder="لینک"
                />
              </CCol>
              <CCol col="4">
                <div><br></div>
                <date-picker
                    v-model="publish_date"
                    label="تاریخ انتشار"
                    type="datetime"
                    format="YYYY-MM-DD HH:mm:ss"
                    input-format="YYYY-MM-DD HH:mm:ss"
                    alt-format="YYYY-MM-DD HH:mm:ss"
                    display-format="jYYYY/jMM/jDD HH:mm:ss"

                />
              </CCol>
            </CRow>
            <CRow>

            </CRow>
            <CRow>
              <CCol col="12">
                <editorjs v-if="loaded_page"
                          editor_id="add_new_editor"
                          :first_content.sync="content_json"
                          :content_json.sync="content_json"
                          :content_text.sync="content_text"
                          :content_html.sync="content_html"
                />

              </CCol>

            </CRow>
            <CRow>

            </CRow>
            <CRow>
              <CCol col="12">
                <CTextarea
                    v-model="seo_summary"
                    class="required"

                    label="سئو توضیحات"

                />
                <SeoProgress :min_perfect="120" :max_perfect="150" :string="seo_summary"/>

              </CCol>
            </CRow>

            <br>

          </CCardBody>

        </CCard>
      </CCol>
      <CCol class="sidebar p-0" col="12 col-md-3" >
        <CCard class="sidebar__inner" >
          <CCardHeader>

            <CButton @click="go_show_blog()" color="primary">نمایش</CButton>

            <CButton v-if="status_form==0" @click="login()" type="submit" ref="submit_form" size="sm" color="primary">
              <CIcon name="cil-check-circle"/>
              ثبت نوشته
            </CButton>
            <CButton v-if="status_form!=0" @click="login()" type="submit" ref="submit_form" size="sm" color="primary">
              <CIcon name="cil-check-circle"/>
              ویرایش نوشته
            </CButton>

          </CCardHeader>
          <CCardBody>
            <p>
              اخرین ویرایش
              {{get_date_time(post_data.updated_at)}}
            </p>
            <CRow>
              <CCol col="12">
                <div >
                  <label>برچسب ها</label>
                </div>
                <treeselect
                    v-model="value_tags"
                    :multiple="true"
                    :async="true"
                    :load-options="load_tags"
                    placeholder="انتخاب برچسب ها"
                    :normalizer="normalizer_tags"
                />


              </CCol>

              <CCol col="12">
                <div class="required">
                  <label>دسته بندی</label>
                </div>
                <treeselect
                    v-model="value_category"
                    :multiple="true"


                    :normalizer="normalizer_category"
                    :append-to-body="true"
                    :options="options_category"
                    placeholder="دسته بندی نوشته را انتخاب کنید"
                />


              </CCol>
            </CRow>
            <br>

            <CRow>
              <CCol col="6">
                <ImageSelector label="تصویر"
                               class="required"
                               :media_id.sync="file"
                               default_archive="blog_post"
                               :preview-image="previewImage"
                />
              </CCol>


            </CRow>
<CRow>
  <CCol col="12" >
  <strong>
    یادداشت های مدیر

  </strong>
  </CCol>

  <CCol col="12" v-for="comment in admin_comments" >
    <div class="p-1 m-1 rounded"  style="border:1px solid gray ">
      <p>
        {{comment.summary}}

      </p>
      <p>
        {{get_date_time(comment.created_at)}},
        {{(comment.user.name)}}

      </p>

    </div>

  </CCol>
  <CCol col="12">
    <CTextarea v-model="comment_summary"
               placeholder="توضیحات"/>
    <CButton
        :disabled="comment_summary.length==0"
        @click="add_post_admin_comment()"
        color="success" >
      ثبت یادداشت
    </CButton>
  </CCol>
</CRow>

          </CCardBody>

        </CCard>

      </CCol>
    </CRow>
<CRow>
  <CCol col="12">
    <CCard>
      <CCardHeader>
        گزارش لینک سازی
      </CCardHeader>
      <CCardBody>
        <BlogLinkSuggestion
            :content="content_html"
            :keyword="keyword"
            :title="title"
        />

      </CCardBody>
    </CCard>

    <CCard>
      <CCardHeader>
        <CButton color="secondary" @click="reload_data_content()">
          <CIcon name="cil-reload"/>
        </CButton>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol>
            <ReadabilitySeoRate
                :content.sync="content_text"
                :html-content="content_html"
                :meta-description="seo_summary"
                :meta-title="seo_title"
                :keyword="keyword"/>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </CCol>

</CRow>
  </div>

</template>

<script>
import editorjs from "@/views/includes/editorjs.vue";
import axios from "axios";

import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import ReadabilitySeoRate from "@/views/includes/ReadabilitySeoRate";
import BlogLinkSuggestion from "./BlogLinkSuggestion.vue";
const simulateAsyncOperation = fn => {
  setTimeout(fn, 2000)
}


export default {
  name: 'Login',
  components: {
    ReadabilitySeoRate,
    Treeselect,
    BlogLinkSuggestion,
    editorjs
    // ckeditor: CKEditor.component
  },
  data() {

    return {
      post_data:{},
      admin_comments:[],
      comment_summary:'',
      editor: null,
      loaded_page: false,
      content_json: {},
      content_text: '',
      content_html: '',
      value_category: [],
      value_tags: [],
      value_keywords: [],
      // define options
      image_upload: '',
      options_category: [],
      normalizer_category(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,
        }
      },

      load_tags({action, searchQuery, callback}) {

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            axios.post('/api/admin/blog/search_blog_tags', {
              search: searchQuery,

            }).then(function (response) {
              options = response.data;
              callback(null, options);
            })
                .catch(function (error) {
                  console.log(error);
                });

          })
        }
      },
      normalizer_tags(node) {
        return {
          id: node.title,
          label: node.title,
        }
      },
      // editor: ClassicEditor,
      editorData: '',
      title: '',
      favorite_url: '',
      publish_date: '',
      seo_title: '',
      keyword: '',
      summary: '',
      seo_summary: '',
      tags: '',
      file: [],

      previewImage: null,
      image: '',

      details: [],
      status_form: 0,

    }
  },
  mounted() {

    this.get_categories();
    if (this.$route.params.post_id != null) {
      this.status_form = this.$route.params.post_id;
      this.get_post_info();
      this.get_admin_comments();

    } else {
      this.loaded_page = true
    }
    new StickySidebar('.sidebar', {
    minWidth: 700,
      topSpacing: 70,
      bottomSpacing: 5,
      containerSelector: '.main-content',
      innerWrapperSelector: '.sidebar__inner'
    });
  },
  watch: {
    '$route.params.post_id': function () {
      this.get_categories();
    },
    // 'editorData': function () {
    //   let tmp = document.createElement("DIV");
    //   tmp.innerHTML = this.editorData;
    //   this.content_text = tmp.textContent || tmp.innerText || "";
    //
    //   this.content_html = this.editorData;
    // },

  },
  methods: {
    async handleAIContent(data) {
      console.log("data ai",data)
      const { blocks } = data;

      // پاک کردن محتوای قبلی
      // await this.editor.blocks.clear();
this.loaded_page = false;
      this.content_json = { "time": 1782542462932, "blocks": blocks, "version": "2.28.2" }

      // اضافه کردن بلوک‌های جدید
      // blocks.forEach(block => {
      //   this.content_json.push(block.type, block.data);
      // });
      var self= this
      setTimeout(function (){
        self.loaded_page = true;

      },500)
      this.showSuccess('محتوای مقاله با موفقیت تولید شد!');
    },
    showSuccess(msg) {
      this.$toast?.success(msg) || alert(msg);
    },

    showError(msg) {
      this.$toast?.error(msg) || alert('خطا: ' + msg);
    },
    go_show_blog() {
      window.open(localStorage.getItem("web_address") + "blog/" + this.favorite_url, "_blank");
    },
    get_categories() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/blog/get_categories_with_children', formData, {}).then(function (response) {
        // console.log("cats is "+response.data.groups);
        // console.log("cats is "+items);

        var content_cats = response.data;

        // items = content_cats.orders;
        self.options_category = content_cats.orders;
        // console.log("cats is "+items);
        // self.description = '';
        // localStorage.setItem("api_token", response.data.access_token);
        // self.$router.push({ path: 'notes' });
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_post_info() {
      var self = this;
      var formData = new FormData();
      formData.append('post_id', self.status_form);
      axios.post('/api/admin/blog/post_info', formData, {}).then(function (response) {
        var post_data = response.data;

        self.file = [post_data.post.image_id];
        self.previewImage = post_data.post.image;
        post_data.post.categories.forEach((val) => {
          self.value_category.push(val.category_id);
        });
        post_data.post.tags.forEach((val) => {
          self.value_tags.push(val.tag.title.title);
        });

        // self.value_category = post_data.post.categories;
        //  self.options_=post_data.post.tags;
        // self.value_keywords=post_data.post.keywords;
        self.title = post_data.post.title.title;
        self.favorite_url = post_data.post.title.slug;
        self.publish_date = post_data.post.publish_date;
        self.content_json = JSON.parse(post_data.post.title.description);

        self.seo_summary = post_data.post.title.short_description;
        self.seo_title = post_data.post.title.seo_title;
        self.keyword = post_data.post.title.keyword;
        self.loaded_page = true
        self.post_data = post_data.post

        // localStorage.setItem("api_token", response.data.access_token);
        // self.$router.push({ path: 'notes' });
      }).catch(function (error) {

        console.log(error);
      });


    },
    get_admin_comments() {


      var self = this;
      var formData = new FormData();
      formData.append('id', self.status_form);
      axios.post('/api/admin/blog/get_post_admin_comments', formData, {}).then(function (response) {
       self.admin_comments = response.data
        // localStorage.setItem("api_token", response.data.access_token);
        // self.$router.push({ path: 'notes' });
      }).catch(function (error) {

        console.log(error);
      });


    },


    login() {
      let self = this;
      const formData = new FormData()
      let url;
      if (self.status_form == 0) {
        url = "/api/admin/blog/insert_post";
      } else {
        url = "/api/admin/blog/update_post";
        formData.append('post_id', this.status_form)

      }

      formData.append('post_image', this.file[0])
      formData.append('cat_list', this.value_category)
      formData.append('tags', this.value_tags)
      formData.append('name', this.title)
      formData.append('url', this.favorite_url)
      formData.append('publish_date', this.publish_date)
      formData.append('text', JSON.stringify(this.content_json))
      formData.append('meta_desc', this.seo_summary)
      formData.append('meta_title', this.seo_title)
      formData.append('keyword', this.keyword)

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);
        if (self.status_form == 0 && res.data.error==0) {
          self.name = '';
          self.mobile = '';
          self.email = '';
          self.description = '';
          self.password = '';
          self.selected_group = '0';
          self.permissions = [];
          window.open("/dashboard/news/all-news","_self")
          // self.$router.go(-1)
        }
      }).catch(function (error) {
        self.$root.modal_component.show_api_response_modals({data:{error:1,msg:'خطا در ثبت'}});

        console.log(error);
      });

    },
    add_post_admin_comment() {
      let self = this;
      const formData = new FormData()
      let url;

        url = "/api/admin/blog/add_post_admin_comment";
        formData.append('id', this.status_form)


      formData.append('summary', this.comment_summary)


      axios.post(url, formData, {}).then((res) => {
       self.get_admin_comments();
      }).catch(function (error) {

        console.log(error);
      });

    }
  }
}


</script>
<style>

</style>
